<template>
  <div id="outer-uebersicht">
    <div id="title-uebersicht">
      <h3>Übersicht der Eingaben</h3>
    </div>
    <div id="patient-uebersicht">
      <h4>Patienteninformation</h4>
      Geburtsjahr: {{ (new Date(patient.birthDate)).getFullYear() }}
      ({{ calculateAgeInYears(new Date(patient.birthDate)) }} Jahre), {{ genderMap[patient.sex] }}
    </div>
    <div id="anfallstypen-uebersicht">
      <h4>Anfallstypen</h4>
      <b-table sticky-header="325px" striped bordered head-variant="light" :fields="anfaelleTableFields"
               :items="anfaelleList">
        <template #cell(rule)="data">
          <div v-b-tooltip.hover.bottom :title="getAnfallstypInfo(data.item)">{{ data.item.rule['Anfallstyp'] }}</div>
        </template>
      </b-table>
    </div>
    <div id="tu-uebersicht">
      <h4>Technische Untersuchungen</h4>
      <b-table sticky-header="325px" striped bordered head-variant="light"
               :fields="untersuchungenListFields"
               :items="untersuchungenList"></b-table>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {calculateAge, localDateFormat} from "../../../js/util";
import infoTexte from "../../../js/clinical-algorithm/infoTexte/infoTexte";

export default {
  name: "UebersichtEingaben",
  data() {
    return {
      localDateFormat: localDateFormat,
      anfaelleTableFields: [
        {
          key: 'rule',
          label: 'Anfallstyp',
          formatter: value => value['Anfallstyp']
        },
        {
          key: 'date',
          label: 'Datum',
          formatter: (value) => localDateFormat(new Date(value)),
          thStyle: {width: '100px'}
        }
      ],
      untersuchungenListFields: [
        {
          key: 'type',
          label: 'Modalität'
        },
        {
          key: 'befund',
          label: 'Befund'
        },
        {
          key: 'date',
          label: 'Datum',
          thStyle: {width: '100px'}
        }
      ],
      genderMap: {
        m: 'Männlich',
        w: 'Weiblich'
      }
    }
  },
  computed: {
    ...mapState('cdss/anfallsanamnese', {
          anfaelleList: state => {
            let anfaelleList = []
            if (state && state.anfaelle) {
              state.anfaelle.forEach(anfall => {
                anfaelleList.push({
                  rule: anfall.rowsUsed[anfall.rowsUsed.length - 1],
                  date: anfall.datum
                })
              })
            }
            return anfaelleList
          }
        }
    ),
    ...mapState('cdss/technischeUntersuchungen', {
      untersuchungenList: state => {
        let untersuchungenList = []
        state.untersuchungen.forEach(untersuchung => {
          untersuchungenList.push({
            date: localDateFormat(new Date(untersuchung.date)),
            befund: untersuchung.value['FINDING_TEXT'],
            type: untersuchung.value['MODALITY']
          })
        })
        return untersuchungenList
      }
    }),
    ...mapGetters('cdss', [
      'patient'
    ]),
    tooltipTextOverview: () => infoTexte.uebersichtEingabenInfoText
  },
  methods: {
    calculateAgeInYears(date) {
      return calculateAge(date)
    },
    getAnfallstypInfo(item) {
      return item.rule['Anfallstyp ausführlich']
    }
  }
}
</script>

<style scoped>
#outer-uebersicht {
  display: grid;
  grid-template-areas: "title" "patient" "anfallstypen" "tu";
  grid-template-columns: 1fr;
  grid-template-rows: 60px 100px auto auto;
  border: solid 1px;
}

#title-uebersicht {
  grid-area: title;
  border-bottom: solid 1px;
  margin-left: 13px;
  margin-right: 13px;
  margin-top: 10px;
}

#patient-uebersicht {
  grid-area: patient;
  font-size: 16pt;
  border-bottom: solid 1px;
  margin-left: 13px;
  margin-right: 13px;
  margin-top: 20px;
  padding-bottom: 20px;
}

#anfallstypen-uebersicht {
  grid-area: anfallstypen;
  border-bottom: solid 1px;
  margin-left: 13px;
  margin-right: 13px;
  margin-top: 20px;
  padding-bottom: 20px;
}

#tu-uebersicht {
  grid-area: tu;
  margin: 20px 13px;
}
</style>
